import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { EstimatedPriceUpdateRecord } from "@/client-admin/types.gen";

interface PriceUpdateTableProps {
  data: EstimatedPriceUpdateRecord;
}

export function PriceUpdateTable({ data }: PriceUpdateTableProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Electricity Prices</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contract</TableHead>
                <TableHead>NL Base Bid</TableHead>
                <TableHead>NL Base Ask</TableHead>
                <TableHead>NL Peak Bid</TableHead>
                <TableHead>NL Peak Ask</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {Object.entries(data.electricity).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{value.contract}</TableCell>
                  <TableCell>{value.nl_base_bid ?? "-"}</TableCell>
                  <TableCell>{value.nl_base_ask ?? "-"}</TableCell>
                  <TableCell>{value.nl_peak_bid ?? "-"}</TableCell>
                  <TableCell>{value.nl_peak_ask ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Gas Prices</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contract</TableHead>
                <TableHead>TTF Bid</TableHead>
                <TableHead>TTF Ask</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {Object.entries(data.gas).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{value.contract}</TableCell>
                  <TableCell>{value.ttf_bid ?? "-"}</TableCell>
                  <TableCell>{value.ttf_ask ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Emission Prices</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contract</TableHead>
                <TableHead>EUA</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {Object.entries(data.emissions).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{value.contract}</TableCell>
                  <TableCell>{value.EUA ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Spark Spread Prices</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Contract</TableHead>
                <TableHead>Spark Spread Base Bid</TableHead>
                <TableHead>Spark Spread Base Ask</TableHead>
                <TableHead>Spark Spread Peak Bid</TableHead>
                <TableHead>Spark Spread Peak Ask</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {Object.entries(data.sparkspread).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell>{value.contract}</TableCell>
                  <TableCell>{value.sparkspread_base_bid ?? "-"}</TableCell>
                  <TableCell>{value.sparkspread_base_ask ?? "-"}</TableCell>
                  <TableCell>{value.sparkspread_peak_bid ?? "-"}</TableCell>
                  <TableCell>{value.sparkspread_peak_ask ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
